<template>
  <div class="profile">
    <SfTabs :open-tab="1">
      <SfTab :title="$t('Personal data')">
        <p>
          {{ $t(`Feel free to edit any of your details
          below so your account is always up to date`) }}
        </p>
        <form @submit.prevent="onUpdateCustomerSubmit" class="fz-form">
          <div class="row">
          <div class="col-xs-12">
            <SfHeading
              class="sf-heading--left"
              :level="3"
              :title="$t('Basic Information')"
            />
          </div>
            <div class="col-xs-12 col-sm-6">
              <SfInput
                v-model="user.FirstName"
                name="firstName"
                :label="$t('First Name')"
                required
              />
            </div>
            <div class="col-xs-12 col-sm-6">
              <SfInput
                v-model="user.LastName"
                name="lastName"
                :label="$t('Last Name')"
                required
              />
            </div>
            <div class="col-xs-12 col-sm-6">
              <SfInput
                v-model="user.Email"
                type="email"
                name="email"
                label="E-mail"
                required
              />
            </div>
            <div class="col-xs-12 col-sm-6">
              <SfInput
                v-model="user.Phone"
                name="phone"
                :label="$t('Phone')"
                type="tel"
              />
            </div>
            <div class="col-xs-12 col-sm-6">
              <SfInput
                v-model="user.Company"
                name="company"
                :label="$t('Company')"
              />
            </div>
            <div class="col-xs-12 col-sm-6">
              <SfInput
                v-model="user.VatNumber"
                name="VatNumber"
                :label="$t('Vat Number')"
              />
            </div>
            <div class="col-xs-12">
              <SfHeading
                class="sf-heading--left"
                :level="3"
                :title="$t('Default Addresses')"
              />
            </div>
            <div class="col-xs-12 col-sm-6">
              <SfSelect
                v-if="addresses.length"
                class="sf-select--underlined"
                v-model="user.BillingAddress"
                name="BillingAddress"
                key="BillingAddress"
                :placeholder="$t('Select option')"
                :label="$t('Billing Address')"
              >
                <SfSelectOption
                  v-for="address in addresses"
                  :key="address.Id"
                  :value="address.Id"
                >
                  {{ address.Address1 }} - {{ address.City }}
                </SfSelectOption>
              </SfSelect>
              <p v-else>
                {{ $t('Addresses list is empty. Please add new address.') }}
              </p>
            </div>
            <div class="col-xs-12 col-sm-6">
              <SfSelect
                v-if="addresses.length"
                class="sf-select--underlined"
                v-model="user.ShippingAddress"
                name="ShippingAddress"
                key="ShippingAddress"
                :placeholder="$t('Select option')"
                :label="$t('Shipping Address')"
              >
                <SfSelectOption
                  v-for="address in addresses"
                  :key="address.Id"
                  :value="address.Id"
                >
                  {{ address.Address1 }} - {{ address.City }}
                </SfSelectOption>
              </SfSelect>
            </div>
            <div class="col-xs-12">
              <SfButton type="submit">{{ $t('Save changes') }}</SfButton>
            </div>
          </div>
        </form>
      </SfTab>
      <SfTab :title="$t('Password change')">
        <p>
          {{ $t(`If you want to change the password to access your account, enter the
          following information:`) }}
          <br />{{ $t('Your current email address is') }}
          <strong>{{ customer.Email }}</strong>
        </p>
        <form @submit.prevent="onSetPasswordSubmit" class="fz-form">
          <div class="row">
            <div class="col-xs-12">
              <SfInput
                v-model="newPassword"
                type="password"
                name="newPassword"
                :label="$t('New Password')"
                required
              />
            </div>
            <div class="col-xs-12">
              <SfInput
                v-model="repeatPassword"
                type="password"
                name="repeatPassword"
                :label="$t('Repeat Password')"
                :valid="valid"
                :error-message="errorMessage"
                required
              />
            </div>
            <div class="col-xs-12">
              <SfButton type="submit">{{ $t('Update password') }}</SfButton>
            </div>
          </div>
        </form>
      </SfTab>
    </SfTabs>
  </div>
</template>

<script>
import {
  SfTabs,
  SfInput,
  SfButton,
  SfHeading,
  SfSelect,
} from '@storefront-ui/vue';
import { config } from '@/modules/core';
import { Base64 } from 'js-base64';
import user from '../../mixins/user';

export default {
  name: 'MyProfile',
  mixins: [user, config],
  components: {
    SfTabs,
    SfInput,
    SfButton,
    SfHeading,
    SfSelect,
  },
  data() {
    return {
      newPassword: '',
      repeatPassword: '',
      errorMessage: 'Password not match.',
      valid: true,
    };
  },
  computed: {
    user() {
      return this.customer;
    },
    addresses() {
      return this.customer.Addresses || [];
    },
  },
  methods: {
    onUpdateCustomerSubmit() {
      this.updateCustomer({
        ...this.user,
      });
    },
    onSetPasswordSubmit() {
      if (this.newPassword !== this.repeatPassword) {
        this.valid = false;
      } else {
        this.valid = true;
        this.setPassword({
          Email: this.user.Email,
          password: Base64.encode(this.newPassword),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.fz-form {
  @include flexbox-mobile {
    .sf-button {
      --button-width: 100%;
    }
  }
  .sf-input,
  .sf-button {
    margin-bottom: var(--spacer-sm);
  }
}

p {
  margin-bottom: var(--spacer-sm);
}

a {
  text-decoration: none;
  color: var(--menu-item-label-color, var(--c-dark-variant));
  &:hover {
    color: var(--c-black);
  }
}
</style>
